window.addEventListener("load", function() {

    const blockHeroVideos = [...document.querySelectorAll(".vimeo-oembed")];

    for (let i = 0; i < blockHeroVideos.length; i++) {
        let blockHeroVideo = blockHeroVideos[i];
        if (blockHeroVideo) {

            initVideo(blockHeroVideo)
        }
    }
});

function initVideo(blockHeroVideo) {
    const playButtonDesktop = blockHeroVideo.querySelector(".play-button-desktop");
    const pauseButtonDesktop = blockHeroVideo.querySelector(".lower-controls.desktop .pause-button");
    const volumeOnButtonDesktop = blockHeroVideo.querySelector(".lower-controls.desktop .volume-on-button");
    const volumeOffButtonDesktop = blockHeroVideo.querySelector(".lower-controls.desktop .volume-off-button");

    const playButtonMobile = blockHeroVideo.querySelector(".play-button-mobile");
    const pauseButtonMobile = blockHeroVideo.querySelector(".lower-controls.mobile .pause-button");
    const volumeOnButtonMobile = blockHeroVideo.querySelector(".lower-controls.mobile .volume-on-button");
    const volumeOffButtonMobile = blockHeroVideo.querySelector(".lower-controls.mobile .volume-off-button");

    const desktopVimeoiFrame = blockHeroVideo.querySelector(".video.desktop iframe");
    const mobileVimeoiFrame = blockHeroVideo.querySelector(".video.mobile iframe");

    if (desktopVimeoiFrame) {
        var vimeoDesktopVideo = new Vimeo.Player(desktopVimeoiFrame);
    }

    if (mobileVimeoiFrame) {
        var vimeoMobileVideo = new Vimeo.Player(mobileVimeoiFrame);
    }

    playButtonDesktop.addEventListener("click", function() {
        vimeoDesktopVideo.play();
        blockHeroVideo.classList.add("playing");

        if (blockHeroVideo.classList.contains("paused")) {
            blockHeroVideo.classList.remove("paused");
        }
    });

    pauseButtonDesktop.addEventListener("click", function() {
        vimeoDesktopVideo.pause();

        blockHeroVideo.classList.remove("playing");
        blockHeroVideo.classList.add("paused");
    });

    volumeOnButtonDesktop.addEventListener("click", function() {
        vimeoDesktopVideo.setVolume(0);

        blockHeroVideo.classList.add("volume-off");

        if (blockHeroVideo.classList.contains("volume-on")) {
            blockHeroVideo.classList.remove("volume-on");
        }
    });

    volumeOffButtonDesktop.addEventListener("click", function() {
        vimeoDesktopVideo.setVolume(1);

        blockHeroVideo.classList.add("volume-on");
        blockHeroVideo.classList.remove("volume-off");
    });

    playButtonMobile.addEventListener("click", function() {
        vimeoMobileVideo.play();
        blockHeroVideo.classList.add("playing");

        if (blockHeroVideo.classList.contains("paused")) {
            blockHeroVideo.classList.remove("paused");
        }
    });

    pauseButtonMobile.addEventListener("click", function() {
        vimeoMobileVideo.pause();

        blockHeroVideo.classList.remove("playing");
        blockHeroVideo.classList.add("paused");
    });

    volumeOnButtonMobile.addEventListener("click", function() {
        vimeoMobileVideo.setVolume(0);

        blockHeroVideo.classList.add("volume-off");

        if (blockHeroVideo.classList.contains("volume-on")) {
            blockHeroVideo.classList.remove("volume-on");
        }
    });

    volumeOffButtonMobile.addEventListener("click", function() {
        vimeoMobileVideo.setVolume(1);

        blockHeroVideo.classList.add("volume-on");
        blockHeroVideo.classList.remove("volume-off");
    });
}